var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 10.6666L4.6665 7.33329L5.59984 6.36663L7.33317 8.09996V2.66663H8.6665V8.09996L10.3998 6.36663L11.3332 7.33329L7.99984 10.6666ZM3.99984 13.3333C3.63317 13.3333 3.31928 13.2027 3.05817 12.9416C2.79706 12.6805 2.6665 12.3666 2.6665 12V9.99996H3.99984V12H11.9998V9.99996H13.3332V12C13.3332 12.3666 13.2026 12.6805 12.9415 12.9416C12.6804 13.2027 12.3665 13.3333 11.9998 13.3333H3.99984Z",
    fill: "#597EF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNew);
export default __webpack_public_path__ + "static/media/download-new.1dcee72396b94fe79be9bf3bcbfff349.svg";
export { ForwardRef as ReactComponent };